// Paid-traffic popup suppression (Eli, Oct 2 2026): visitors who land from Google Ads never see the
// email/discount popup for the rest of the browser session. Runs first, before any popup timer.
const NO_POPUP_KEY = 'andros_no_popup';
const PAID_CLICK_IDS = ['gclid', 'gbraid', 'wbraid'];

function shouldSuppressPopup(loc = window.location, store = window.sessionStorage) {
  let isPaidLanding = false;
  try {
    const params = new URLSearchParams(loc.search || '');
    params.forEach((value, key) => {
      const name = key.toLowerCase();
      if (PAID_CLICK_IDS.includes(name)) isPaidLanding = true;
      if (name === 'utm_source' && value.trim().toLowerCase() === 'google') isPaidLanding = true;
    });
  } catch (error) {
    isPaidLanding = false;
  }
  try {
    if (isPaidLanding) store.setItem(NO_POPUP_KEY, '1');
    return isPaidLanding || store.getItem(NO_POPUP_KEY) === '1';
  } catch (error) {
    return isPaidLanding; // sessionStorage unavailable: still suppress on the landing page itself
  }
}

const suppressPopup = shouldSuppressPopup();

// Klaviyo popup TXmLbU custom trigger. Approved by Eli Oct 3 2026 (4:53 PM ET); timing changed Oct 8 2026 (CRO plan #7/#69,
// Eli: "Yes do it all"). Runs after the paid-traffic suppression above. The theme popup stays off.
// Opens the welcome offer (10% off any bundle) when the visitor reaches ~50% of the page, OR shows exit intent (desktop: cursor
// leaves through the top of the window), OR on phones after ~30 s on the page, whichever comes first.
// Never once anything is in the cart (checked live against /cart.js right before opening). Kept guards: at most once per
// session, not within 3 days of the last open/close, never after a signup, never on cart/checkout/account pages, never for
// paid Google traffic (sessionStorage andros_no_popup=1). Debug: window.androsKlTrigger.
// Oct 9 2026: when the theme renders the ANDROS dropper popup (Theme settings → Welcome popup = dropper, see
// snippets/andros-dropper-popup.liquid), the same trigger opens it instead of TXmLbU (never both). Set the setting back
// to "Klaviyo form TXmLbU" to restore the Klaviyo popup. QA: ?andros_popup=1 forces the active popup open (skips guards).
(function androsKlaviyoTrigger() {
  try {
    var FORM_ID = 'TXmLbU';
    var DROPPER = !!document.getElementById('andros-dropper');
    var openPopup = function (trigger, forced) {
      if (DROPPER) {
        var o = { trigger: trigger, forced: !!forced };
        window.androsDropperQ = window.androsDropperQ || [];
        window.androsDropperQ.push(o);
      } else {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', FORM_ID]);
      }
    };
    try {
      if (/(^|[?&])andros_popup=1(&|$)/.test(window.location.search.slice(1)) || window.location.hash === '#andros_popup') {
        window.androsKlTrigger = { formId: DROPPER ? 'andros-dropper' : FORM_ID, state: 'forced' };
        var forceOpen = function () { setTimeout(function () { openPopup('forced', true); }, 400); };
        if (document.readyState === 'complete') forceOpen(); else window.addEventListener('load', forceOpen, { once: true });
        return;
      }
    } catch (e) {}
    // Oct 9 2026 10:17 PM ET (Eli): the dropper opens 5 s after page load for everyone, once per session (first page they stay
    // 5 s on). No scroll/exit/30 s triggers, no 3-day cooldown, no cart / paid-traffic guards. Kept: never after a signup,
    // never on cart/checkout/account pages, at most once per session. The Klaviyo-form mode below keeps its old rules.
    if (DROPPER) {
      var st5 = (window.androsKlTrigger = { formId: 'andros-dropper', state: 'waiting', rules: 'load+5s|once_per_session' });
      var why5 = function () {
        if (/^\/(cart|checkout|checkouts|account)(\/|$)/i.test(window.location.pathname || '/')) return 'path';
        try { if (localStorage.getItem('andros_kl_done') === '1') return 'signed_up'; } catch (e) {}
        try { if (sessionStorage.getItem('andros_kl_opened') === '1') return 'already_opened_this_session'; } catch (e) {}
        return '';
      };
      var r5 = why5();
      if (r5) { st5.state = 'skipped'; st5.reason = r5; return; }
      var arm5 = function () {
        st5.state = 'armed';
        setTimeout(function () {
          var late = why5();
          if (late) { st5.state = 'skipped'; st5.reason = late; return; }
          try { sessionStorage.setItem('andros_kl_opened', '1'); } catch (e) {}
          openPopup('load_5s', false);
          st5.state = 'opened'; st5.trigger = 'load_5s'; st5.at = Date.now();
        }, 5000);
      };
      if (document.readyState === 'complete') arm5(); else window.addEventListener('load', arm5, { once: true });
      return;
    }
    var SCROLL_PCT = 50;
    var PHONE_DELAY_MS = 30000;
    var COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;
    var isPhone = false;
    try { isPhone = window.matchMedia('(pointer: coarse)').matches && window.matchMedia('(max-width: 767px)').matches; } catch (e) {}
    var status = (window.androsKlTrigger = { formId: DROPPER ? 'andros-dropper' : FORM_ID, state: 'waiting', device: isPhone ? 'phone' : 'desktop', rules: 'scroll' + SCROLL_PCT + (isPhone ? '|phone' + PHONE_DELAY_MS / 1000 + 's' : '|exit_intent') });
    var done = false;
    var timer = null;

    window.addEventListener('klaviyoForms', function (event) {
      try {
        var d = (event && event.detail) || {};
        if (d.formId !== FORM_ID) return;
        if (d.type === 'submit' || d.type === 'stepSubmit') localStorage.setItem('andros_kl_done', '1');
        if (d.type === 'close') localStorage.setItem('andros_kl_last', String(Date.now()));
      } catch (e) {}
    });

    var blockedReason = function () {
      var path = (window.location.pathname || '/').toLowerCase();
      if (/^\/(cart|checkout|checkouts|account)(\/|$)/.test(path)) return 'path';
      if (suppressPopup || sessionStorage.getItem(NO_POPUP_KEY) === '1') return 'paid_traffic';
      if (localStorage.getItem('andros_kl_done') === '1') return 'signed_up';
      if (sessionStorage.getItem('andros_kl_opened') === '1') return 'already_opened_this_session';
      var last = parseInt(localStorage.getItem('andros_kl_last') || '0', 10);
      if (last && Date.now() - last < COOLDOWN_MS) return 'cooldown_3_days';
      if (sessionStorage.getItem('andros_has_cart') === '1') return 'cart_has_items';
      if (document.body && document.body.classList.contains('cart-open')) return 'cart_open';
      return '';
    };

    var disarm = function () {
      done = true;
      if (timer) clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onMouseOut);
      document.removeEventListener('cart:open', onCart);
    };

    var skip = function (reason) { status.state = 'skipped'; status.reason = reason; disarm(); };

    var fire = function (trigger) {
      if (done) return;
      var reason = blockedReason();
      if (reason) { skip(reason); return; }
      done = true; // claim it now so a second trigger can't race the cart check
      status.trigger = trigger;
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return cart && cart.item_count > 0; }, function () { return false; })
        .then(function (hasItems) {
          if (hasItems) { try { sessionStorage.setItem('andros_has_cart', '1'); } catch (e) {} skip('cart_has_items'); return; }
          var late = blockedReason();
          if (late) { skip(late); return; }
          sessionStorage.setItem('andros_kl_opened', '1');
          localStorage.setItem('andros_kl_last', String(Date.now()));
          openPopup(trigger, false);
          status.state = 'opened'; status.at = Date.now();
          disarm();
        })
        .catch(function () { status.state = 'error'; disarm(); });
    };

    function onScroll() {
      var doc = document.documentElement;
      var max = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0) - window.innerHeight;
      if (max <= 0) return;
      if ((window.scrollY / max) * 100 >= SCROLL_PCT) fire('scroll_' + SCROLL_PCT);
    }
    function onMouseOut(e) {
      if (!e.relatedTarget && !e.toElement && e.clientY <= 0) fire('exit_intent');
    }
    function onCart() { try { sessionStorage.setItem('andros_has_cart', '1'); } catch (e) {} if (!done) skip('cart_has_items'); }

    var arm = function () {
      if (done) return;
      status.state = 'armed';
      window.addEventListener('scroll', onScroll, { passive: true });
      if (isPhone) timer = setTimeout(function () { fire('phone_' + PHONE_DELAY_MS / 1000 + 's'); }, PHONE_DELAY_MS);
      else document.addEventListener('mouseout', onMouseOut);
      document.addEventListener('cart:open', onCart);
    };

    var early = blockedReason();
    if (early && early !== 'cart_open') { status.state = 'skipped'; status.reason = early; return; }
    if (document.readyState === 'complete') arm();
    else window.addEventListener('load', arm, { once: true });
  } catch (e) {}
})();

const fadeObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      fadeObserver.unobserve(entry.target);
    });
  },
  {
    threshold: 0.08,
    rootMargin: '0px 0px -40px 0px',
  }
);

document.querySelectorAll('[data-fade-in], [data-fade-in-stagger], [data-line-animate]').forEach((element) => {
  fadeObserver.observe(element);
});

const navToggleBtn = document.querySelector('[data-nav-toggle]');
const mobileNavDrawer = document.querySelector('[data-mobile-nav]');

if (navToggleBtn && mobileNavDrawer) {
  const closeMobileNav = () => {
    mobileNavDrawer.classList.remove('is-open');
    mobileNavDrawer.setAttribute('aria-hidden', 'true');
    navToggleBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
  };

  navToggleBtn.addEventListener('click', () => {
    const isOpen = mobileNavDrawer.classList.toggle('is-open');
    navToggleBtn.setAttribute('aria-expanded', String(isOpen));
    mobileNavDrawer.setAttribute('aria-hidden', String(!isOpen));
    document.body.classList.toggle('nav-open', isOpen);
  });

  mobileNavDrawer.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMobileNav);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileNavDrawer.classList.contains('is-open')) {
      closeMobileNav();
      navToggleBtn.focus();
    }
  });
}

const popup = document.getElementById('email-popup');

if (popup) {
  const enabled = popup.dataset.popupEnabled !== 'false' && !suppressPopup;
  const delaySec = parseInt(popup.dataset.popupDelay ?? '6', 10);
  const scrollPct = parseInt(popup.dataset.popupScroll ?? '40', 10);
  const storageKey = 'andros_popup_dismissed';
  const popupLauncher = document.querySelector('[data-popup-launcher]');
  const popupSuccess = popup.querySelector('[data-popup-success="true"]');
  const popupError = popup.querySelector('[data-popup-error="true"]');

  if (suppressPopup && popupLauncher) popupLauncher.style.display = 'none';

  function openPopup(force = false) {
    if (!enabled) return;
    if (!force && sessionStorage.getItem(storageKey)) return;

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('popup-open');
    popupLauncher?.setAttribute('aria-expanded', 'true');
    popup.querySelector('input, button, a')?.focus();
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('popup-open');
    popupLauncher?.setAttribute('aria-expanded', 'false');
    sessionStorage.setItem(storageKey, '1');
  }

  if (popupSuccess || popupError) {
    openPopup(true);
  } else if (enabled && !sessionStorage.getItem(storageKey)) {
    const delayTimer = setTimeout(() => openPopup(), delaySec * 1000);

    function onScroll() {
      const docHeight = document.body.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;

      const scrolled = (window.scrollY / docHeight) * 100;
      if (scrolled >= scrollPct) {
        clearTimeout(delayTimer);
        openPopup();
        window.removeEventListener('scroll', onScroll);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  popupLauncher?.addEventListener('click', () => openPopup(true));

  popup.querySelectorAll('[data-popup-close]').forEach((element) => {
    element.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
      popupLauncher?.focus();
    }
  });
}
